package org.teddapp.project.ui.focus

import org.teddapp.project.ui.TeddIconButton

import org.teddapp.project.ui.TeddTabs
import org.teddapp.project.ui.ReorderableColumn
import org.teddapp.project.ui.rememberReorderableState

import org.teddapp.project.ui.TeddTab

import org.teddapp.project.ui.TeddSpace

import org.teddapp.project.ui.TeddScreenHeader

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInHorizontally
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutHorizontally
import androidx.compose.animation.slideOutVertically
import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.tedd.db.Pomodoro_check
import com.tedd.db.Pomodoro_item
import com.tedd.db.Pomodoro_session
import com.tedd.db.Task
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.teddapp.project.db.TeddRepositories
import org.teddapp.project.db.nowMillis
import org.teddapp.project.ui.TeddButton
import org.teddapp.project.ui.TeddButtonKind
import org.teddapp.project.ui.TeddButtonSize
import org.teddapp.project.ui.TeddIcon
import org.teddapp.project.ui.TeddLogo
import org.teddapp.project.ui.TeddTokens
import org.teddapp.project.ui.nav.Section
import org.teddapp.project.ui.pomodoro.POM_PRESET_DURATIONS
import org.teddapp.project.ui.pomodoro.POM_TODAY_ISO
import org.teddapp.project.ui.pomodoro.PomPriority
import org.teddapp.project.ui.pomodoro.formatMmSs
import org.teddapp.project.ui.pomodoro.isoAddDays
import org.teddapp.project.ui.pomodoro.resolveItemTitle

// ──────────────────────────────────────────────────────────────────────
// Parties propres à la mise en page étendue (tablette, ordinateur) :
// en-tête du centre et liste détaillée des tâches.
// ──────────────────────────────────────────────────────────────────────

@Composable
internal fun FocusExpandedHeader(
    session: Pomodoro_session,
    tab: FocusTab,
    onTab: (FocusTab) -> Unit,
    onToggleSettings: () -> Unit,
) {
    TeddScreenHeader(
        title = "Focus",
        overline = "Liste du jour · ${session.timer_minutes} min",
        modifier = Modifier.padding(start = TeddSpace.S8, end = TeddSpace.S6, top = TeddSpace.S5, bottom = TeddSpace.S3),
    ) {
        TeddTabs(
        tabs = listOf(
            TeddTab(FocusTab.Today.name, "Aujourd'hui"),
            TeddTab(FocusTab.History.name, "Historique"),
            TeddTab(FocusTab.Review.name, "Révisions"),
        ),
            selected = tab.name,
            onSelect = { name -> FocusTab.entries.firstOrNull { it.name == name }?.let(onTab) },
        )
        TeddIconButton(onClick = onToggleSettings) {
            TeddIcon(name = "settings", size = 16.dp, color = TeddTokens.InkMuted)
        }
    }
}

// ──────────────────────────────────────────────────────────────────────
// Extension banner
// ──────────────────────────────────────────────────────────────────────

@Composable
internal fun FocusExpandedItemsList(
    items: List<Pomodoro_item>,
    resolveMeta: (Pomodoro_item) -> ItemMeta,
    selectedId: String?,
    onSelect: (String) -> Unit,
    onToggle: (Pomodoro_item) -> Unit,
    onStartTimer: (Pomodoro_item) -> Unit,
    onSetPriority: (Pomodoro_item, PomPriority) -> Unit,
    onRemove: (Pomodoro_item) -> Unit,
    repos: TeddRepositories,
    onEdit: (Pomodoro_item) -> Unit = {},
    /** Glisser une ligne pour la classer parmi celles de même priorité. */
    onMove: ((Int, Int) -> Unit)? = null,
) {
    if (items.isEmpty()) {
        FocusEmptyToday()
        return
    }
    // Un appui long sur une ligne la saisit ; on la lâche à sa nouvelle place. La
    // colonne n'est pas paresseuse : une journée compte quelques dizaines de lignes.
    val reorder = rememberReorderableState()
    ReorderableColumn(
        items = items,
        keyOf = { it.id },
        state = reorder,
        onReorder = { from, to -> onMove?.invoke(from, to) },
        modifier = Modifier.fillMaxSize().verticalScroll(rememberScrollState()).padding(horizontal = 16.dp, vertical = 10.dp),
    ) { index, item, handle ->
        val meta = resolveMeta(item)
        val checks by repos.pomodoroChecks.observeByItem(item.id).collectAsState(emptyList())
        // Un dépôt ne doit pas compter comme un clic sur la ligne.
        val locked = reorder.recentlyDropped
        val canUp = onMove != null && canMoveWithinGroup(items, index, -1)
        val canDown = onMove != null && canMoveWithinGroup(items, index, +1)
        Box(modifier = Modifier.fillMaxWidth().padding(bottom = 3.dp).then(if (onMove != null) handle else Modifier)) {
            PomodoroItemRow(
                onMoveUp = if (canUp) ({ onMove?.invoke(index, index - 1) }) else null,
                onMoveDown = if (canDown) ({ onMove?.invoke(index, index + 1) }) else null,
                item = item,
                meta = meta,
                selected = selectedId == item.id,
                onSelect = { if (!locked) onSelect(item.id) },
                onToggle = { if (!locked) onToggle(item) },
                onStartTimer = { onStartTimer(item) },
                onSetPriority = { p -> onSetPriority(item, p) },
                onRemove = { onRemove(item) },
                verifsDone = checks.count { it.checked != 0L },
                verifsTotal = checks.size,
                onEdit = { onEdit(item) },
            )
        }
    }
}

// ──────────────────────────────────────────────────────────────────────
// Right panel
// ──────────────────────────────────────────────────────────────────────
